import useToast from './ToastManager';

export default useToast;
